class CampaignHelper {

    static mfoSlugs = ['/lakasbiztositas-kampany', '/march-campaign'];

    static isItHomeInsuranceCampaign() {
        const url = window.location.href;
        return CampaignHelper.mfoSlugs.some(slug => url.includes(slug));
    }
}

export default CampaignHelper;
